import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import InitialSection from "../components/home/initial-section"

import PricingSection from '../components/home/pricing-section'

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <InitialSection />
    <PricingSection />
  </Layout>
)

export default IndexPage
